import { DifficultyRating } from 'src/api/media/types';
import { getSnowplowSchema } from './getSnowplowSchema';

export const CLIENT_ENTITY_SCHEMA = 'iglu:com.memrise/client_entity/jsonschema/1-0-0';
export const COMMUNICATE_SESSION_STARTED_SCHEMA = getSnowplowSchema('CommunicateSessionStart');
export const COMMUNICATE_SESSION_COMPLETED_SCHEMA = getSnowplowSchema('CommunicateSessionEnd');
export const CONTENT_MEDIA_ENTITY_SCHEMA = 'iglu:com.memrise/content_media_entity/jsonschema/1-0-1';
export const CONTENT_MEDIA_STARTED_SCHEMA = getSnowplowSchema('ContentMediaStarted');
export const CONTENT_MEDIA_COMPLETED_SCHEMA = getSnowplowSchema('ContentMediaCompleted');
export const LANGUAGE_PAIR_ENTITY_SCHEMA = 'iglu:com.memrise/language_pair_entity/jsonschema/1-0-1';
export const LEARNING_SESSION_STARTED_SCHEMA = getSnowplowSchema('LearningSessionStarted');
export const LEARNING_SESSION_COMPLETED_SCHEMA = getSnowplowSchema('LearningSessionCompleted');
export const SKILL_LEVEL_SELECTED_SCHEMA = getSnowplowSchema('SkillLevelSelected');
export const USER_ENTITY_SCHEMA = 'iglu:com.memrise/user_entity/jsonschema/1-0-1';

type AppType = 'memrise-android' | 'memrise-ios' | 'memrise-web' | 'unknown';

export const getClientEntity = (
  type: AppType,
  osVersion?: string | null,
  appVersion?: string | null,
) => ({
  schema: CLIENT_ENTITY_SCHEMA,
  data: {
    type: !['memrise-android', 'memrise-ios', 'memrise-web'].includes(type) ? 'unknown' : type,
    os_version: osVersion ?? null,
    app_version: appVersion ?? null,
  },
});

export const getContentMediaEntity = (
  contentMediaId: number,
  diffRating?: DifficultyRating | null,
  duration?: number | null,
  mediaType?: string | null,
  url?: string | null,
) => ({
  schema: CONTENT_MEDIA_ENTITY_SCHEMA,
  data: {
    content_media_id: contentMediaId,
    difficulty_rating: diffRating ?? null,
    duration_seconds: duration ?? null,
    media_type: mediaType ?? null,
    url: url ?? null,
  },
});

export const getLanguagePairEntity = (
  languagePairId: number | null,
  targetLanguageLocale?: string | null,
  targetLanguageName?: string | null,
  sourceLanguageLocale?: string | null,
  sourceLanguageName?: string | null,
) => ({
  schema: LANGUAGE_PAIR_ENTITY_SCHEMA,
  data: {
    language_pair_id: languagePairId,
    target_language_locale: targetLanguageLocale ?? null,
    target_language_name: targetLanguageName ?? null,
    source_language_locale: sourceLanguageLocale ?? null,
    source_language_name: sourceLanguageName ?? null,
  },
});

export const getUserEntity = (
  userId: number,
  isPro: boolean,
  datetimeJoinedUTC?: string | null,
  username?: string | null,
) => ({
  schema: USER_ENTITY_SCHEMA,
  data: {
    user_id: userId,
    is_pro: isPro,
    datetime_joined_utc: datetimeJoinedUTC ?? null,
    username: username ?? null,
  },
});
